<template>
  <div class="min-h-screen bg-white">
    <!-- 헤더 -->
    <AppHeader title="이용약관" />

    <!-- 콘텐츠 -->
    <div class="max-w-3xl mx-auto px-4 py-8 pb-32">
      <!-- 서비스 정보 -->
      <div class="mb-8">
        <h1 class="text-2xl font-bold text-slate-900 mb-2">물어다줄개 이용약관</h1>
        <p class="text-sm text-slate-500">시행일: 2024년 1월 1일</p>
      </div>

      <!-- 약관 내용 -->
      <div class="space-y-8">
        <!-- 제1조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제1조 (목적)</h2>
          <p class="text-slate-600 leading-relaxed">
            이 약관은 이에스랩스 코퍼레이션(이하 "회사")이 운영하는 '물어다줄개' 서비스(이하 "서비스")의 이용조건 및 절차, 회사와 이용자의 권리, 의무 및 책임사항 등을 규정함을 목적으로 합니다.
          </p>
        </section>

        <!-- 제2조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제2조 (정의)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2">
              <li><strong>"서비스"</strong>란 회사가 제공하는 부동산 분양 정보 제공 및 상담사 매칭 플랫폼을 의미합니다.</li>
              <li><strong>"이용자"</strong>란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
              <li><strong>"회원"</strong>이란 서비스에 가입하여 아이디(ID)를 부여받은 자를 말합니다.</li>
              <li><strong>"파트너"</strong>란 분양 상담사로 등록된 회원을 말합니다.</li>
              <li><strong>"현장"</strong>이란 분양 중인 부동산 프로젝트를 의미합니다.</li>
              <li><strong>"포인트"</strong>란 서비스 내에서 사용되는 가상 화폐 또는 적립금을 말합니다.</li>
            </ul>
          </div>
        </section>

        <!-- 제3조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제3조 (약관의 효력 및 변경)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
            <p>② 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</p>
            <p>③ 약관이 변경되는 경우, 회사는 변경 내용을 시행일 7일 전부터 서비스 내 공지사항을 통해 공지합니다.</p>
            <p>④ 회원은 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.</p>
          </div>
        </section>

        <!-- 제4조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제4조 (회원가입 및 서비스 이용)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 이용자는 회사가 정한 절차에 따라 회원가입을 신청할 수 있습니다.</p>
            <p>② 회사는 다음 각 호에 해당하는 경우 회원가입을 거절하거나 사후에 이용계약을 해지할 수 있습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-4">
              <li>실명이 아니거나 타인의 정보를 도용한 경우</li>
              <li>허위 정보를 기재하거나 필수 정보를 누락한 경우</li>
              <li>관련 법령을 위반하여 이용 신청을 하는 경우</li>
              <li>기타 서비스 운영에 지장을 초래하는 경우</li>
            </ul>
            <p>③ 회원은 가입 시 등록한 정보에 변경이 있는 경우 즉시 수정해야 합니다.</p>
          </div>
        </section>

        <!-- 제5조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제5조 (서비스의 제공)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>회사는 다음과 같은 서비스를 제공합니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2">
              <li>부동산 분양 현장 정보 제공</li>
              <li>분양 상담사 매칭 서비스</li>
              <li>상담 신청 및 관리 서비스</li>
              <li>커뮤니티 서비스</li>
              <li>포인트 적립 및 사용 서비스</li>
              <li>기타 회사가 정하는 서비스</li>
            </ul>
          </div>
        </section>

        <!-- 제6조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제6조 (서비스의 변경 및 중단)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 운영상, 기술상의 필요에 따라 서비스를 변경할 수 있습니다.</p>
            <p>② 회사는 다음 각 호의 경우 서비스 제공을 일시적으로 중단할 수 있습니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-4">
              <li>설비 점검, 교체 및 보수 등의 경우</li>
              <li>전기통신사업법에 정한 기간통신사업자의 서비스 중지</li>
              <li>천재지변, 국가비상사태 등 불가항력적 사유</li>
            </ul>
            <p>③ 서비스 중단 시 회사는 사전에 공지하며, 불가피한 경우 사후에 공지할 수 있습니다.</p>
          </div>
        </section>

        <!-- 제7조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제7조 (이용자의 의무)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>이용자는 다음 행위를 해서는 안 됩니다.</p>
            <ul class="list-disc list-inside space-y-1 ml-2">
              <li>타인의 정보를 도용하는 행위</li>
              <li>서비스를 이용하여 얻은 정보를 무단으로 복제, 유통하는 행위</li>
              <li>회사 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
              <li>음란물, 허위정보 등을 게시하는 행위</li>
              <li>서비스의 안정적 운영을 방해하는 행위</li>
              <li>기타 관련 법령에 위반되는 행위</li>
            </ul>
          </div>
        </section>

        <!-- 제8조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제8조 (파트너 서비스)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 파트너로 등록하고자 하는 회원은 회사가 정한 절차에 따라 신청해야 합니다.</p>
            <p>② 파트너는 명함 등 증빙서류를 제출하여 자격을 증명해야 합니다.</p>
            <p>③ 파트너는 한 번에 하나의 현장에만 소속될 수 있으며, 변경은 30일마다 가능합니다.</p>
            <p>④ 파트너는 고객 정보를 적법하게 처리하고, 상담 의무를 성실히 이행해야 합니다.</p>
            <p>⑤ 파트너가 의무를 위반할 경우 회사는 파트너 자격을 제한하거나 해지할 수 있습니다.</p>
          </div>
        </section>

        <!-- 제9조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제9조 (포인트)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 서비스 이용에 따라 이용자에게 포인트를 부여할 수 있습니다.</p>
            <p>② 포인트는 서비스 내에서만 사용할 수 있으며, 현금으로 환전되지 않습니다.</p>
            <p>③ 포인트의 적립 기준, 사용 범위, 유효기간 등은 회사 정책에 따릅니다.</p>
            <p>④ 부정한 방법으로 포인트를 취득한 경우 회사는 포인트를 회수할 수 있습니다.</p>
          </div>
        </section>

        <!-- 제10조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제10조 (콘텐츠의 권리와 책임)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 이용자가 서비스에 게시한 콘텐츠의 저작권은 해당 이용자에게 있습니다.</p>
            <p>② 회사는 서비스 운영을 위해 이용자 콘텐츠를 복제, 전송, 전시할 수 있습니다.</p>
            <p>③ 이용자는 타인의 저작권을 침해하는 콘텐츠를 게시해서는 안 됩니다.</p>
            <p>④ 회사는 관련 법령에 위반되는 콘텐츠를 사전 통지 없이 삭제할 수 있습니다.</p>
          </div>
        </section>

        <!-- 제11조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제11조 (책임의 제한)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 회사는 천재지변, 전쟁 등 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</p>
            <p>② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임지지 않습니다.</p>
            <p>③ 회사는 이용자 간 또는 이용자와 제3자 간의 분쟁에 개입하지 않으며, 이에 대한 책임을 지지 않습니다.</p>
            <p>④ 분양 현장 정보는 참고용이며, 최종 정보는 해당 시행사/시공사에 확인해야 합니다.</p>
          </div>
        </section>

        <!-- 제12조 -->
        <section>
          <h2 class="text-lg font-bold text-slate-900 mb-3">제12조 (분쟁 해결)</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 서비스 이용과 관련하여 분쟁이 발생한 경우, 회사와 이용자는 상호 협의하여 해결합니다.</p>
            <p>② 협의가 이루어지지 않을 경우, 관할 법원은 민사소송법에 따른 법원으로 합니다.</p>
          </div>
        </section>

        <!-- 부칙 -->
        <section class="pt-4 border-t border-slate-200">
          <h2 class="text-lg font-bold text-slate-900 mb-3">부칙</h2>
          <div class="text-slate-600 leading-relaxed space-y-2">
            <p>① 본 약관은 2024년 1월 1일부터 시행됩니다.</p>
            <p>② 본 약관에 명시되지 않은 사항은 관련 법령 및 회사의 정책에 따릅니다.</p>
          </div>
        </section>

        <!-- 회사 정보 -->
        <section class="mt-12 p-6 bg-slate-50 rounded-2xl">
          <h3 class="font-bold text-slate-900 mb-3">이에스랩스 코퍼레이션</h3>
          <div class="text-sm text-slate-600 space-y-1">
            <p>대표: 심응선</p>
            <p>사업자등록번호: 227-31-01670</p>
            <p>주소: 충청북도 청주시 서원구 충대로1, S1-3동 2층 201호 충북대학교 충북Pro메이커센터</p>
            <p>이메일: eslabsofficial@gmail.com</p>
            <p>고객센터: 1533-9012</p>
          </div>
        </section>
      </div>
    </div>

    <!-- 푸터 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name: 'TermsView',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>
